var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.63C14.49 11.63 16.52 9.60003 16.52 7.11003C16.52 4.62003 14.49 2.59003 12 2.59003C9.50998 2.59003 7.47998 4.62003 7.47998 7.11003C7.47998 9.60003 9.50998 11.63 12 11.63Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7 12.72H11.3C6.77999 12.72 3.10999 16.39 3.10999 20.91C3.10999 21.19 3.32999 21.41 3.60999 21.41H20.39C20.67 21.41 20.89 21.19 20.89 20.91C20.89 16.39 17.22 12.72 12.7 12.72Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClient);
export default __webpack_public_path__ + "static/media/client.e0f62965.svg";
export { ForwardRef as ReactComponent };